// 对外展示文案；中文直接使用调用处的原文。
const messages = {
    "全部项目": {
        "en": "All projects",
        "ja": "すべて"
    },
    "项目与实践": {
        "en": "Projects & practice",
        "ja": "プロジェクト・実績"
    },
    "从技术判断到系统实现，再到业务使用与持续演进。": {
        "en": "From technical decisions to working systems and sustained business use.",
        "ja": "技術判断からシステム実装、業務活用と継続的な改善まで。"
    },
    "回看能力全景": {
        "en": "Explore capabilities",
        "ja": "専門領域に戻る"
    },
    "项目分类": {
        "en": "Categories",
        "ja": "カテゴリー"
    },
    "检索项目": {
        "en": "Search projects",
        "ja": "プロジェクト検索"
    },
    "名称、方向或关键词…": {
        "en": "Name, category or keyword…",
        "ja": "名称・分野・キーワード…"
    },
    "个项目": {
        "en": "projects",
        "ja": "件"
    },
    "项匹配": {
        "en": "projects found",
        "ja": "件のプロジェクト"
    },
    "详情与架构": {
        "en": "Details & architecture",
        "ja": "詳細・アーキテクチャ"
    },
    "查看详情": {
        "en": "View details",
        "ja": "詳細を見る"
    },
    "没有匹配的项目": {
        "en": "No matching projects",
        "ja": "該当するプロジェクトはありません"
    },
    "清除筛选": {
        "en": "Clear filters",
        "ja": "条件をクリア"
    },
    "能力维度": {
        "en": "Capability areas",
        "ja": "専門領域"
    },
    "技术深度": {
        "en": "Technical depth",
        "ja": "技術的な専門性"
    },
    "主导职责": {
        "en": "Leadership scope",
        "ja": "主導した役割"
    },
    "代表实践": {
        "en": "Selected practice",
        "ja": "実践例"
    },
    "相关经历": {
        "en": "Related work",
        "ja": "関連する取り組み"
    },
    "播放动效": {
        "en": "Play animation",
        "ja": "アニメーションを再生"
    },
    "暂停动效": {
        "en": "Pause animation",
        "ja": "アニメーションを停止"
    },
    "项目详情章节": {
        "en": "Project sections",
        "ja": "プロジェクト詳細の項目"
    },
    "成果重点": {
        "en": "Key outcomes",
        "ja": "主な成果"
    },
    "系统架构": {
        "en": "Architecture",
        "ja": "アーキテクチャ"
    },
    "实现与验证": {
        "en": "Implementation & validation",
        "ja": "実装・検証"
    },
    "查看相关说明": {
        "en": "View related implementation",
        "ja": "関連する実装の説明"
    },
    "适应宽度": {
        "en": "Fit to width",
        "ja": "幅に合わせる"
    },
    "放大图": {
        "en": "Enlarge",
        "ja": "拡大"
    },
    "架构视图": {
        "en": "Architecture views",
        "ja": "表示形式"
    },
    "架构与机制": {
        "en": "Architecture & mechanisms",
        "ja": "構成・仕組み"
    },
    "交互结构": {
        "en": "Interactive view",
        "ja": "インタラクティブ図"
    },
    "显示暗色配图": {
        "en": "Show dark diagram",
        "ja": "ダーク表示に切り替え"
    },
    "显示原色配图": {
        "en": "Show original colors",
        "ja": "元の配色に切り替え"
    },
    "暗色": {
        "en": "Dark colors",
        "ja": "ダーク表示"
    },
    "原色": {
        "en": "Original colors",
        "ja": "元の配色"
    },
    "查看原图": {
        "en": "Open image",
        "ja": "画像を開く"
    },
    "项目架构配图，放大后可横向滚动查看": {
        "en": "Project architecture image. Scroll horizontally when enlarged.",
        "ja": "プロジェクト構成図。拡大時は横にスクロールできます。"
    },
    "点击节点，查看职责与边界": {
        "en": "Select a node to explore its role",
        "ja": "ノードを選択すると役割を表示"
    },
    "架构图画布，可横向滚动查看": {
        "en": "Interactive architecture. Scroll horizontally to explore.",
        "ja": "インタラクティブ構成図。横にスクロールできます。"
    },
    "实线箭头表示数据或调用关系，虚线箭头表示控制与验证。": {
        "en": "Solid arrows show data flow or calls; dashed arrows show control and validation.",
        "ja": "実線はデータの流れ・呼び出し、破線は制御・検証を示します。"
    },
    "关键设计": {
        "en": "Design decisions",
        "ja": "設計の要点"
    },
    "返回架构总览": {
        "en": "Back to overview",
        "ja": "全体構成に戻る"
    },
    "系统逻辑视图": {
        "en": "Logical system view",
        "ja": "システムの論理構成"
    },
    "使用入口": {
        "en": "Entry points",
        "ja": "利用者の入口"
    },
    "计算 / 服务": {
        "en": "Compute / services",
        "ja": "処理・サービス"
    },
    "数据 / 证据": {
        "en": "Data / evidence",
        "ja": "データ・根拠"
    },
    "控制 / 验证": {
        "en": "Control / validation",
        "ja": "制御・検証"
    },
    "事件流": {
        "en": "Event stream",
        "ja": "イベント"
    },
    "外部能力": {
        "en": "External services",
        "ja": "外部サービス"
    },
    "职责与贡献": {
        "en": "Responsibilities & contributions",
        "ja": "担当業務・貢献"
    },
    "能力概览": {
        "en": "Capabilities at a glance",
        "ja": "専門性の概要"
    },
    "工作与项目全景": {
        "en": "Experience & projects",
        "ja": "職務経歴・プロジェクト"
    },
    "技术视野": {
        "en": "Technical perspective",
        "ja": "技術的な専門性"
    }
};

export const t = (lang, text) => lang === 'zh' ? text : messages[text]?.[lang] || text;
